import React from "react";
import DateHelper from "../DateHelper/DateHelper";
import DatePickerInput from '../DatePickerInput/DatePickerInput';
import { subDays, addDays, parseISO } from 'date-fns';

class ReservationSegmentCardDateSelector extends React.Component {

  constructor(props) {
    super(props);
    this._onChangeCheckInDate = this._onChangeCheckInDate.bind(this);
    this._onChangeCheckOutDate = this._onChangeCheckOutDate.bind(this);
  };

  render() {

    var check_in_date = typeof this.props.reservation_segment.check_in_date == "string" ? parseISO(this.props.reservation_segment.check_in_date) : this.props.reservation_segment.check_in_date
    var check_out_date = typeof this.props.reservation_segment.check_in_date == "string" ? parseISO(this.props.reservation_segment.check_out_date) : this.props.reservation_segment.check_out_date
    var min_date = subDays(new Date(), 1);

    return (
      <div className="date-selector row spacer">
        <div className="col-sm-6">
          <label>{I18n.t('arrival')}</label>

          {
            !this.props.read_only && this.props.reservation_segment.rate
              ?
              <DatePickerInput
                selectedDate={this.props.reservation_segment.check_in_date || ""}
                dateFormat={this.props.date_format}
                onChange={this._onChangeCheckInDate}
                minDate={min_date}
                maxDate={addDays(new Date(), 364)}
              />
              :
              <div>{DateHelper.printDateToScreen(check_in_date, this.props.date_format)}</div>
          }
        </div>
        {this.props.daily_rental ? null :
          <div className="col-sm-6">
            
            <label>{I18n.t('departure')}</label>
            <span>{` (${this.props.reservation_segment.number_of_nights} ${this.props.reservation_segment.number_of_nights > 1 ? I18n.t('nights') : I18n.t('night')})`}</span>

            {
              !this.props.read_only && this.props.reservation_segment.rate
                ?
                <div>
                  <DatePickerInput
                    selectedDate={this.props.reservation_segment.check_out_date || ""}
                    dateFormat={this.props.date_format}
                    onChange={this._onChangeCheckOutDate}
                    minDate={new Date()}
                    maxDate={addDays(new Date(), 364)}
                  />
                </div>
                :
              <div>{DateHelper.printDateToScreen(check_out_date, this.props.date_format)}</div>
            }
          </div>
        }
      </div>
    );
  };

  _onChangeCheckInDate(checkInDate) {
    var self = this
    if (this.props.daily_rental) {
      const newCheckInDate = new Date(checkInDate);
      const newCheckOutDate = addDays(newCheckInDate, 1);
      self.props.onChangeDates(newCheckInDate, newCheckOutDate);
      return;
    }
    self.props.onChangeDates(new Date(checkInDate), self.props.reservation_segment.check_out_date);
  };

  _onChangeCheckOutDate(checkOutDate) {
    this.props.onChangeDates(this.props.reservation_segment.check_in_date, new Date(checkOutDate));
  };

};

export default ReservationSegmentCardDateSelector
